import { withInstall } from '@element-plus/utils'

import Transfer from './src/transfer.vue'

export const ElUnidirectionalTransfer = withInstall(Transfer)
export default ElUnidirectionalTransfer

export * from './src/transfer'
